import { api } from '../api';

export const siteService = {
  async getSitesList(params) {
    return api.get('sites/list', { params });
  },
};